import React from 'react'
import classNames from 'classnames'
import * as styles from './TitleLockup.module.scss'

export interface TitleLockupProps {
  headingLevel: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  visualStyle: 'h1' | 'h2' | 'h3' | 'h4' | 'h5'
  useAltText?: boolean
  align?: 'left' | 'center'
  title: string
  titleAlt?: string
  textWrap?: boolean | 'desktopOnly' | 'mobileOnly' | 'mobileAndTablet'
  showHeadingDivider?: boolean
}

const TitleLockup: React.FC<TitleLockupProps> = ({
  headingLevel: Heading,
  visualStyle,
  useAltText = false,
  align = 'left',
  title,
  titleAlt = '',
  textWrap = false,
  showHeadingDivider = false
}) => {
  return (
    <>
      <Heading
        className={classNames(styles.titleLockup, styles[visualStyle], {
          [styles.altText]: useAltText,
          [styles.center]: align === 'center',
          [styles.textWrap]: textWrap === true,
          [styles.textWrapDesktop]: textWrap === 'desktopOnly',
          [styles.textWrapMobile]: textWrap === 'mobileOnly',
          [styles.textWrapMobileAndTablet]: textWrap === 'mobileAndTablet',
        })}
      >
        {title}
        {titleAlt && <span>{titleAlt}</span>}
      </Heading>
      {showHeadingDivider && <hr className={styles.headingDivider} />}
    </>
  )
}

export default TitleLockup
